import { Endpoint } from '../endpoint';
import { BattlePlanTaskCommentResponse, CommentId, TaskId } from '@business/entities/battle_plan';

export function fetchComments(taskId: TaskId, isCompact?: boolean) {
  return Endpoint.get<BattlePlanTaskCommentResponse[]>(`@makh/battle-plan-comments/${taskId}`, { params: { isCompact } });
}

export function fetchComment(id: CommentId) {
  return Endpoint.get<BattlePlanTaskCommentResponse>(`@makh/battle-plan-comments/comment/${id}`);
}

export function createComment(data: Partial<BattlePlanTaskCommentResponse>) {
  return Endpoint.post<BattlePlanTaskCommentResponse>(`@makh/battle-plan-comments`, { data });
}

export function deleteComment(commentId: CommentId) {
  return Endpoint.delete<void>(`@makh/battle-plan-comments/${commentId}`);
}
